import {Service} from "../Service";

export class EmpleadoService extends Service{
    constructor() {
        super('colaboradores/');
    }

    obtenerEmpleados() {
        return this.http.get(this.getUrl(['obtener','colaboradores']))
            .then((response) => this.onData(response))
            .catch(() => {
                throw new Error('Error al guardar los datos')
            })
            .finally(() => {
                this.onFinaly();
            })
    }
}